import React, { useEffect, useState, useCallback } from 'react';
import { message } from 'antd';
import { useLocation, useHistory } from 'react-router';

import { Cronometro } from '../../components/Cronometro';
import { TabsBox } from './TabsBox';

import {
  getAtendimentoEmAndamento,
  getSolicitacaoEmAndamento,
  getImgMotoristaCNH,
  getImgSelfieMotorista,
  getImgsVeiculos,
} from '../../services';

import colors from '../../styles/colors';
import * as S from './styles';

export function Atendimento(fn) {
  const history = useHistory();
  const location = useLocation();
  const ref = React.useRef(fn);
  const [atendimento, setAtendimento] = useState(null);
  const [solicitacao, setSolicitacao] = useState([]);
  const [imgsMotorista, setImgsMotorista] = useState({});
  const [imgsVeiculo, setImgsVeiculo] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [observacaoInterna, setObservacaoInterna] = useState();

  const carregarAtendimentoEmAndamento = useCallback(async () => {
    const { data, error } = await getAtendimentoEmAndamento();

    if (data) {
      return setAtendimento(data);
    }

    if (error) {
      message.error(
        error?.response?.data?.detail ||
          'Não foi possível iniciar o atendimento.'
      );
      return history.push('/painel-de-controle');
    }
  }, [history]);

  const carregarSolicitacaoAtual = useCallback(async () => {
    setSpinning(true);
    const { data, error } = await getSolicitacaoEmAndamento();

    if (data) {
      setSpinning(false);
      setSolicitacao(data);
      setObservacaoInterna(data?.observacaoInterna);
      return;
    }

    if (error) {
      setSpinning(false);
      error?.response?.data?.detail &&
        message.error(
          error?.response?.data?.detail || 'Erro ao buscar atendimento.'
        );
      setSpinning(false);
    }
  }, []);

  const carregarImagensVeiculo = useCallback(async () => {
    const listImgVeiculoss = await Promise?.allSettled(
      await solicitacao?.veiculos?.map(
        async item => await getImgsVeiculos(item?.placa)
      )
    ).then(res => res.map(item => item?.value?.data));
    return setImgsVeiculo(listImgVeiculoss);
  }, [solicitacao]);

  const carregarImagensMotorista = useCallback(async () => {
    const listMgsMotorista = await Promise?.allSettled([
      getImgMotoristaCNH(solicitacao?.motorista?.documento),
      getImgSelfieMotorista(solicitacao?.motorista?.documento),
    ]).then(res => res.map(item => item?.value?.data));

    return setImgsMotorista(listMgsMotorista);
  }, [solicitacao]);

  useEffect(() => {
    carregarAtendimentoEmAndamento();
  }, [history, carregarAtendimentoEmAndamento]);

  useEffect(() => {
    atendimento && carregarSolicitacaoAtual();
  }, [carregarSolicitacaoAtual, atendimento]);

  useEffect(() => {
    if (!!solicitacao?.veiculos) {
      carregarImagensVeiculo();
    }
    if (!!solicitacao?.motorista?.documento) {
      carregarImagensMotorista();
    }
  }, [solicitacao, carregarImagensMotorista, carregarImagensVeiculo]);

  useEffect(() => {
    if (location.pathname === '/atendimento') {
      window.addEventListener(
        'beforeunload',
        event => {
          event.preventDefault();
          event.returnValue = '';
        },
        [ref]
      );
    }
  }, [location.pathname, history]);

  return (
    <S.PageSpin
      spinning={spinning}
      size="large"
      description="Carregando dados TmovGR!"
    >
      <S.Page>
        <S.AttendanceHeader>
          <S.Title color={colors.blue} size={32}>
            {`Solicitação: #${solicitacao?.idIntegracao || ''}`}
          </S.Title>
          {atendimento && (
            <S.DivProgress id="progress">
              <Cronometro
                title="Análise de cadastro"
                url="/consultas-externas-painel"
                minutes={atendimento?.tempoLimiteCronometro || 0}
                emAndamento={atendimento}
                observacaoInterna={observacaoInterna}
              />
            </S.DivProgress>
          )}
        </S.AttendanceHeader>
        <S.Wrapper>
          <S.ContainerConsultas>
            <TabsBox
              solicitacao={solicitacao}
              imgsMotorista={imgsMotorista}
              imgsVeiculo={imgsVeiculo}
              tipoSolicitacao={atendimento?.idTipoValidacao}
              carregarSolicitacaoAtual={carregarSolicitacaoAtual}
              setSpinning={setSpinning}
              setObservacaoInterna={setObservacaoInterna}
              observacaoInterna={observacaoInterna}
            />
          </S.ContainerConsultas>
        </S.Wrapper>
      </S.Page>
    </S.PageSpin>
  );
}
